export default {
  // Sidebar Navigation
  sidebar: {
    dashboard: "Painel",
    plans: "Planos",
    organizationDesign: "Design da Organização",
    evaluation: "Avaliação",
    talentPool: "Pool de Talentos",
    reports: "Relatórios",
    notifications: "Notificações",
    switchOrg: "Mudar Organização"
  },
  // Talent Pool / Users Page
  talentPool: {
    relationshipAddedSuccessfully: "Relacionamento adicionado com sucesso",
    relationshipRemovedSuccessfully: "Relacionamento removido com sucesso",
    relationshipSavedSuccessfully: "Relacionamento Salvo com Sucesso",
    profileCard: "Cartão de Perfil",
    viewOptions: {
      plan: "Plano",
      hierarchy: "Hierarquia",
      network: "Rede"
    },
    searchPlaceholder: "Pesquisar usuários...",
    networkSearchPlaceholder: "Pesquisar rede...",
    hierarchySearchPlaceholder: "Pesquisar hierarquia...",
    // KVDR Notifications
    kvdrNotifications: {
      create: "Criar",
      roleCreatedSuccessfully: "Função criada com sucesso",
      delete: "Excluir",
      roleDeletedSuccessfully: "Função excluída com sucesso",
      addProfile: "Adicionar Perfil",
      profileAddedSuccessfully: "Perfil adicionado com sucesso",
      removeProfile: "Remover Perfil",
      profileRemovedSuccessfully: "Perfil removido com sucesso",
      roleUpdate: "Atualização de Função",
      updatedSuccessfully: "Atualizado com sucesso",
      profileUpdate: "Atualização de Perfil",
      profileUpdatedSuccessfully: "Perfil atualizado com sucesso"
    },
    title: "Pool de talentos",
    reviewRequest: "Solicitação de revisão",
    // Main talent pool
    noPendingRequest: "Nenhuma solicitação pendente encontrada",
    dropresume: "Solte os currículos para importar",
    processingResume: "Processando currículos...",
    draganddropPopup: "Arraste e largue o seu currículo aqui",
    Clicktoselectfiles: "ou clique para selecionar arquivos",
    Supportedfileformats: "Formatos de arquivo suportados: PDF, DOC, DOCX, TXT.",
    Maxuploadsize: "Máximo 10 arquivos por upload.",
    processingStatus: "Status de processamento",
    importResumes: "Importar currículos",
    downloadResume: "Baixar currículo",
    loading_Resume: "Carregando currículo",
    Resume_Preview: "Visualização de currículo",
    UploadNewResume: "Enviar novo currículo",
    choosefile: "Escolher arquivo",
    AddMembers: "Adicionar membros",
    previewNotAvailable: "Visualização não disponível",
    download: "Baixar",
    roleTitle: "Título da Função",
    firstName: "Primeiro Nome",
    lastName: "Sobrenome",
    email: "E-mail",
    accessLevel: "Nível de acesso",
    AddRelationship: "Adicionar relacionamento",
    RelationshipSavedSuccessfully: "Relacionamento salvo com sucesso",
    RelationshipAddedSuccessfully: "Relacionamento adicionado com sucesso",
    RelationshipRemovedSuccessfully: "Relacionamento removido com sucesso",

    Resume_not_found: "Currículo não encontrado",
    we_could_not_find_resume: "Não conseguimos encontrar um currículo para",
    pleaseSelectFile: "Por favor, selecione um arquivo suportado para enviá-lo agora.",
    verify: "Verificar e enviar",
    uploading: "Enviando...",
    career_objective: "Objetivo Profissional",
    no_objective_provided: "Nenhum objetivo fornecido",
    view_talent_card: "Ver cartão de talento",
    skills: "Habilidades",
    deactivateUserTitle: "Desativar usuário da organização",
    areYouSure: "Tem certeza de que deseja desativar",
    fromThisOrganization: "desta organização?",
    deactivate_user: "Desativar usuário",
    deactivationInProgress: "Desativação em andamento...",
    confirm: "Confirmar",
    noEmailOnRecord: "Nenhum email registrado para este usuário",
    contact_info: "Informações de Contato",
    processingComplete: "Processamento completo",
    uploadingAndParsing: "Enviando e analisando...",
    parsingProfiles: "Analisando perfis...",
    total_progress: "Progresso total",
    Batches_in_queue: "Lotes na fila",
    processed: "processados",
    finish: "Finalizar",
    done: "Concluído",
    failed: "Falhou",
    Uploading_batch: "Enviando lote...",
    Upload_More_Resumes: "Enviar Mais Currículos",
    importFrom: "Importar de",
    uploadExcel: "enviar excel",
    uploadResumes: "enviar currículos",
    uploadResumesTooltip: "Importar desde currículos (PDF)",
    orHRIS: "ou HRIS",
    pendingRequest: "Solicitação pendente",
    allUsers: "Todos os usuários",
    addNewEmployee: "Adicionar novo cartão de funcionário",
    // Table headers
    name: "Nome",
    email: "E-mail",
    maxRole: "Função máxima",
    relationships: "Relacionamentos",
    action: "Ação",
    // User search
    searchUser: "Pesquisar usuário",
    userNotFound: "Usuário não encontrado.",
    // Relationship management
    member: "Membro",
    relationship: "Relacionamento",
    addRelation: "Adicionar relacionamento",
    removeRelationship: "Remover relacionamento"
  },
  // Settings Help Page
  settingsHelp: {
    frequentlyAskedQuestions: "Perguntas Frequentes",
    question1: "Como gerencio as configurações da minha organização?",
    question2: "Como posso convidar novos membros para minha organização?",
    question3: "Quais são os diferentes papéis e permissões de usuário?",
    question4: "Como personalizo a marca da minha organização?",
    helpText: "Este é um texto de ajuda de exemplo. Entre em contato com o suporte para assistência específica com as configurações e configuração da sua organização."
  },
  // Create Organization
  createOrganization: {
    organizationName: "Nome da organização",
    organizationUsername: "Nome de usuário da organização",
    website: "Site",
    workEmail: "Email de trabalho",
    location: "Localização",
    organizationType: "Tipo de organização",
    primaryThemeColor: "Cor do tema principal",
    secondaryThemeColor: "Cor do tema secundário",
    about: "Sobre",
    saveChanges: "Salvar alterações",
    usernameExists: "Este nome de usuário já existe",
    usernameAvailable: "Este nome de usuário está disponível",
    organizationTypeOptions: {
      business: "Negócio",
      academic: "Acadêmico",
      recruiter: "Recrutador"
    },
    logo: {
      adjustTitle: "Ajustar logo da organização",
      save: "Salvar",
      uploadButton: "Enviar logo",
      incorrectFileType: "Tipo de arquivo incorreto",
      incorrectFileTypeText: "Por favor envie um tipo de arquivo de imagem suportado, ex. jpg, png, etc.",
      fileSizeExceeded: "Tamanho do arquivo de imagem excedido",
      fileSizeExceededText: "O tamanho da imagem de perfil deve ser menor que 1MB."
    }
  },

  // Main Organizations List
  main: {
    select: "Selecionar",
    acceptInvitation: "Aceitar convite",
    noOrganizationFound: "Nenhuma organização encontrada!",
    noOrganizationSubtext: "Crie sua própria organização primeiro.",
    createOrganization: "Criar organização"
  },

  // Organization Dashboard
  organization: {
    welcomeBack: "Bem-vindo de volta! 👋",
    setupComplete: "Configuração completa!",
    setupProgress: "Configuração: {step} de 4",
    copyLink: "Copiar link",
    linkCopied: "Link copiado",
    criticalRoles: "Funções críticas",
    talentPool: "Pool de talentos",
    integrations: "Integrações",
    onboarding: "Integração",
    activeCandidates: "Candidatos ativos",
    connectedApps: "Aplicativos conectados",
    pendingOnboards: "Integrações pendentes",
    kvdrReportsCenter: "Centro de relatórios KVDR",
    kvdrReportsDescription: "Mergulhe em seus relatórios de dados visuais chave e obtenha insights críticos.",
    exploreReports: "Explorar relatórios >",
    talentPoolExplorer: "Explorador de pool de talentos",
    talentPoolDescription: "Descubra, analise e gerencie seus melhores talentos com insights abrangentes.",
    exploreTalentPool: "Explorar pool de talentos >",
    thisMonth: "este mês",
    goToOnboarding: "Ir para integração",

    addWebsiteLink: "Adicionar link do website",

    keyRoles: "Funções-chave",
    activePlans: "Planos Ativos",
    completedPlans: "Planos Concluídos",
    viewCandidates: "Ver Candidatos",
    accrossOrganization: "Em Toda a Organização",
    viewBoards: "Ver Quadros",
    archived: "Arquivados / Finalizados",

    topRolesDistribution: "Distribuição das Principais Funções",
    employees: "Colaboradores",
    noData: "Ainda não há dados disponíveis.",

    plansVelocity: "Velocidade dos Planos",
    pv_desc: "Comparação entre planos estratégicos ativos e concluídos.",
    active: "Ativo",
    completed: "Concluído",

    kvdrReports: "Relatórios KVDR",
    kvdrReports_desc: "Gerar insights e descarregar relatórios visuais",
    talentExplorer: "Explorador de Talentos",
    talentExplorer_desc: "Gerir candidatos e colaboradores",

    allSet: "Tudo pronto!",
    stepInProgress: "Etapa em progresso:",
    completeProg: "O perfil da sua organização está 100% completo.",
    incompleteProg: "Está na etapa {onboardingStep} de 4. Complete o seu perfil para desbloquear todas as funcionalidades.",
    continueSetup: "Continuar Configuração",
    viewDetails: "Ver Detalhes",

    onboardingSteps: {
      welcome: "Bem-vindo",
      welcome_desc1: "Vamos configurar o seu pool de talentos para iniciar a sua jornada KVDR e impulsionar a sua estratégia de talento!",
      welcome_desc2: "Siga estes passos para alinhar o talento com o que realmente gera resultados de negócio e construir um ecossistema de talentos baseado em dados.",
      step1_title: "Definir Funções da Organização",
      step1_desc: "Estruture equipas em torno de funções críticas para o valor do negócio.",
      step2_title: "Adicionar Talento",
      step2_desc: "Importe dados de pessoas a partir de qualquer fonte.",
      step3_title: "Avaliar",
      step3_desc: "Configure os seus indicadores para avaliar o talento com base no que mais importa para a sua organização.",
      step4_title: "Planear",
      step4_desc: "Transforme insights em ações de adequação, desenvolvimento e sucessão com um plano de talento para cada função.",
      next: "Seguinte",
      previous: "Anterior",
      done: "Concluído",
      import: "Importar &",
      finish: "Finalizar",

      step1: {
        title: "Estrutura da Organização",
        description: "Inicializámos o espaço de trabalho da sua organização. Clique abaixo para personalizar os seus departamentos, funções e configurações de hierarquia no Planeador de Organização.",
        departments: "Departamentos",
        departments_desc: "Gerir unidades de negócio",
        roles: "Funções",
        roles_desc: "Definir cargos",
        hierarchy: "Hierarquia",
        hierarchy_desc: "Definir linhas de reporte",
        instructions: "Clique em qualquer cartão acima para abrir o Planeador de Organização, ou clique em 'Seguinte' para prosseguir para a Importação.",
      },

      step2: {
        title: "Escolha o seu método de upload",
        title2: "Ficheiros de Currículo",
        description: "Arraste e solte ou clique para procurar",
        instructions: "Formatos suportados: PDF, .txt, .doc, .docx",
      },

      step4: {
        title: "Passo Final:",
        title2: "Está no Passo 4 de 4. Reveja abaixo os seus insights de talento.",
        button: "Finalizar Configuração",
      },
    }
  },

  // Reports
  reports: {
    title: "Relatórios",
    nineCellMatrix: "Matriz de nove células",
    xyPlot: "Gráfico XY",
    talentScoreCard: "Cartão de pontuação de talentos",
    emptyReports: "Relatórios vazios",
    createKVDRFirst: "Crie primeiro um KVDR e planeje para ver relatórios",
    // XY Plot specific
    xAxis: "Eixo X",
    yAxis: "Eixo Y",
    bubbleSize: "Tamanho da bolha",
    loadingChart: "Carregando gráfico...",
    howToReadChart: "Como ler este gráfico",
    positioning: "Posicionamento",
    horizontalPosition: "A posição horizontal mostra",
    verticalPosition: "A posição vertical mostra",
    bubbleRepresentation: "Representação de bolhas",
    eachBubbleRepresents: "Cada bolha representa um funcionário",
    sizeIndicates: "O tamanho indica",
    quadrants: "Quadrantes",
    topLeft: "Superior-Esquerda",
    topRight: "Superior-Direita",
    bottomLeft: "Inferior-Esquerda",
    bottomRight: "Inferior-Direita",
    low: "Baixo",
    high: "Alto",
    interaction: "Interação",
    hoverOverBubble: "Passe o mouse sobre uma bolha",
    revealsDetailedMetrics: "Revela métricas detalhadas para esse funcionário",
    colorCoding: "Codificação de cores",
    differentColorsHelp: "Cores diferentes ajudam a distinguir funcionários",
    // Nine Cell Matrix specific
    nineCellMatrixTitle: "Categorização de funcionários por matriz de nove células",
    methodologyDescription: "Metodologia padronizada baseada em pontuação de desempenho e prontidão para sucessão",
    loading: "Carregando...",
    preparingMatrix: "Preparando a matriz de nove células...",
    noDataAvailable: "Nenhum dado disponível",
    employeeAssessmentRequired: "Dados de avaliação de funcionários são necessários para exibir a matriz de nove células.",
    successionReadiness: "Prontidão para sucessão",
    performanceScore: "Pontuação de desempenho",
    bargain: "BARGAIN",
    bind: "VINCULAR",
    backup: "BACKUP",
    onTrack: "NO CAMINHO",
    boost: "IMPULSIONAR",
    build: "CONSTRUIR",
    bootBarter: "BOOT/TROCA",
    employees: "Funcionários",
    methodologyTitle: "Metodologia da matriz de nove células",
    methodologySubtitle: "Categorização padronizada de funcionários baseada em cálculos de pontuação de desempenho e prontidão para sucessão.",
    calculationMethod: "Método de cálculo",
    performanceScoreFormula: "Pontuação de desempenho (P)",
    performanceScoreCalculation: "P = 0,6 × Desempenho + 0,4 × Avaliação",
    performanceScoreNote: "As pontuações brutas (-1 a 1,5) são normalizadas para escala 0-100",
    successionReadinessFormula: "Prontidão para sucessão (R)",
    successionReadinessCalculation: "R = 0,5 × Sucessão + 0,3 × Adequação + 0,2 × Pontuação de anos",
    successionReadinessNote: "As pontuações brutas (-1 a 1,5) são normalizadas para escala 0-100",
    yearsScore: "Pontuação de anos",
    yearsScoreCalculation: "Se Anos ≥ 3: 100, senão: (Anos / 3) × 100",
    yearsScoreNote: "Atualmente usa 2 anos por padrão (configurável)",
    cellCategories: "Categorias de células",
    backupDescription: "Alto desempenho, Alta sucessão",
    boostDescription: "Desempenho médio, Alta sucessão",
    bindDescription: "Alta/Média sucessão, Desempenho baixo/médio",
    onTrackDescription: "Desempenho médio/baixo, Sucessão média/baixa",
    buildDescription: "Desempenho médio, Sucessão baixa",
    bargainDescription: "Desempenho baixo, Alta sucessão",
    bootBarterDescription: "Alto desempenho, Sucessão baixa",
    // Talent Score Card specific
    criteria: "Critérios",
    talent: "TALENTO",
    role: "FUNÇÃO",
    remarks: "OBSERVAÇÕES",
    weightage: "Ponderação",
    good: "Bom (8-10)",
    average: "Médio (5-7)",
    poor: "Ruim (1-4)",
    notApplicable: "Não aplicável"
  },

  onboarding: {
    define_kvdr: "Definir KVDRs - Funções Críticas",
    align_talent: "ALINHAR TALENTOS AO QUE IMPULSIONA O NEGÓCIO",
    map_org: "Mapeie sua organização identificando:",
    core_func: "Funções principais e departamentos",
    kvdr: "Funções-Chave de Entrega de Valor (funções que impactam materialmente a estratégia e o crescimento)",
    reporting: "Linhas de reporte e criticidade das funções",
    outcome: "Resultado:",
    tile1: "Um plano organizacional alinhado ao negócio com a visualização de um organograma.",
    tile2: "Um banco de talentos ativo e pesquisável pronto para análise; interno e externo.",
    tile3: "Sinais de talento com redução de viés e visão voltada para o futuro.",
    tile4: "Planos de talentos baseados em dados para contratação, capacitação, sucessão e crescimento.",
    completed: "Concluído",
    start_now: "Começar agora",
    talent_ecosystem: "Construa Seu Ecossistema de Talentos",
    single_source: "FONTE ÚNICA DE VERDADE PARA OS DADOS DAS PESSOAS",
    bring_workforce: "Traga sua força de trabalho para o GetBoarded por meio de:",
    uploading_cvs: "Upload de CVs, Excel ou perfis de função",
    hris: "Conectando seu HRIS (se disponível)",
    enrichment: "Enriquecimento com habilidades, capacidades e aspirações",
    career_trajectories: "Avaliar Trajetórias de Carreira",
    beyond_performance: "ALÉM DE ESTATÍSTICAS DE DESEMPENHO E POTENCIAL",
    configure: "Configure como o talento é avaliado por meio de:",
    gb_trajectories: "Usando os modelos de trajetória do GetBoarded (Fitment, Performance, Sucessão)",
    custom_parameters: "Personalizando parâmetros alinhados ao seu contexto",
    weighing_signals: "Pesando os sinais que importam agora e no futuro",
    talent_plans: "Gerar Planos de Talentos",
    insights_to_execution: "TRANSFORME INSIGHTS EM EXECUÇÃO",
    unlock: "Desbloqueie instantaneamente:",
    role_talent: "Insights de desalinhamento entre função e talento",
    risk_mapping: "Prontidão para sucessão e mapeamento de riscos",
    mobility: "Planos de contratação, mobilidade e desenvolvimento"
},

  // Users
  users: {
    title: "Usuários",
    manageUsers: "Gerenciar usuários",
    // User Recommendations
    talentRecommendations: "Planos Recomendados",
    guide: "Guia",
    paid: "PAGO",
    free: "GRÁTIS",
    open: "Abrir",
    looksgood: "Parece bom, próximo",
    design: "Criar minha jornada",
    launchplan: "Lançar Plano",
    pay: "Pagar e Lançar",
    plansummary: "Resumo do Plano",
    ordersummary: "Resumo do Pedido",
    back: "Voltar",
    addstep: "Adicionar uma etapa",
    journeyHint: "Os participantes irão progredir por estas etapas de cima para baixo. Você sempre poderá alterar isso depois.",
    finishPayment: "Finalize o pagamento para ativar seu plano",
    participants: "participantes",
    paymentdetails: "Detalhes do pagamento",
    noMatches: "Ninguém corresponde à sua busca",
    added: "adicionado",
    step: "Etapa",
    designedjourney: "Aqui está a jornada que criamos",
    designedjournerydesc: "Toque em qualquer título ou descrição para editá-lo. Você também pode adicionar ou remover etapas.",
    creatingJourney: "Criando sua jornada...",
    designingSteps: "Criando as etapas que os participantes irão seguir",
    suggestedname: "Nome sugerido",
    howManyParticipants: "Quantos participantes?",
    setNumberOfPeople: "Defina o número de pessoas que passarão por este plano. Você poderá adicioná-las pelo nome depois.",
    total: "Total",
    stepsinjourney: "etapas na jornada",
    continue: "Continuar para Pagamento",
    recommendationsDescription: "Com base na sua avaliação KVDR, aqui estão planos personalizados para a sua organização",
    viewActivePlans: "Ver planos ativos",
    // Recommendation Cards
    hiringPlan: "Plano de contratação",
    hiringPlanDescription: "Espaço de trabalho de rastreamento de candidatos",
    hiringPlanDescription1: "Um espaço de trabalho estruturado para rastrear candidatos através do seu pipeline, desde a prospecção até a integração.",
    hiringPlanContent1: "Rastreamento de pipeline",
    hiringPlanContent2: "Gerenciamento de candidatos",
    hiringPlanContent3: "Estágios personalizáveis",
    fitmentPlan: "Plano de adequação",
    fitmentPlanDescription: "Integração de pessoas em seus papéis.",
    fitmentPlanContent: "Integração de pessoas em seus papéis. Mapeamento do talento certo para os papéis certos com indicadores de adequação",
    developmentPlan: "Plano de desenvolvimento",
    developmentPlanDescription: "Aprendizagem alimentada por IA com ALEX",
    developmentPlanContent: "Criação de planos de aprendizagem com ALEX Caminhos de aprendizagem personalizados para aumentar o valor do talento com habilidades.",
    successionPlanning: "Planejamento de sucessão",
    successionPlanningDescription: "Promover e apoiar o crescimento da carreira",
    successionPlanningContent: "Promover e apoiar o crescimento da carreira Planos de coaching para prontidão de habilidades e tempo para o próximo papel.",
    // Benefits Lists
    roadToRole: "Caminho para seu papel (Jornada)",
    skillProfiling: "Perfilamento de habilidades",
    learningCredits: "Créditos de aprendizagem",
    marketRewards: "Recompensas do mercado",
    customLearningPaths: "Caminhos de aprendizagem personalizados",
    aiAssistedValidation: "Validação assistida por IA",
    progressTracking: "Acompanhamento do progresso com Créditos de Aprendizagem",
    interactiveExercises: "Exercícios interativos",
    appraisalIndicators: "Indicadores de avaliação 360°",
    goalSettingMentorship: "Definição de metas e mentoria",
    careersuccession: "Sucessão de Carreira & Planejamento",
    behaviouralCoaching: "Coaching comportamental e planos",
    managedCareerGuidance: "Orientação de carreira gerenciada",
    starthiring: "Contratando",
    startonboarding: "Integrando",
    startdevelopment: "Desenvolvendo",
    startcoaching: "Treinamento",
    myplans: "Meus Planos",
    workspaces: "Gerencie os espaços de trabalho da sua organização",
    loadingplans: "Carregando seus planos...",
    completePayment: "Concluir Pagamento",
    gettingstarted: "Começando",
    learnsetup: "Aprenda como configurar e gerenciar planos de talentos para sua organização",
    needhelp: "Precisa de ajuda? Entre em contato conosco em",
    letsgetustarted: "Vamos Começar",
    loadingmembers: "Carregando membros...",
    manageplan: "Gerenciar Plano",
    cancel: "Cancelar",
    updatemembers: "Atualizar Membros",
    describeGoal: "Qual é o objetivo?",
    starttemplate: "Ou comece a partir de um modelo",
    describeParticipants: "Descreva o que os participantes devem passar. Nós projetaremos a jornada para você.",
    updateparticipants: "Atualize os participantes inscritos neste plano.",
    tailorplandesc: "Nossa equipe adaptará este plano às necessidades da sua organização e o deixará pronto para você. Envie-nos uma mensagem e cuidaremos do resto.",
    // Action Buttons
    onboard: "Integrar",
    activate: "Ativar",
    promote: "Promover",
    // Progress Section
    talentCapabilitySnapshot: "Instantâneo de capacidades de talento",
    lastUpdated: "Última atualização: Hoje",
    refresh: "Atualizar",
    // Score Labels
    industryLeader: "Líder da indústria",
    highPerforming: "Alto desempenho",
    competitive: "Competitivo",
    developing: "Em desenvolvimento",
    foundationBuilding: "Construção de fundamentos",
    // Notifications
    alexActivated: "ALEX ativado",
    alexActivatedText: "Seu assistente de aprendizagem de IA está pronto para ajudar!",
    coachingRequestSent: "Solicitação de coaching enviada",
    coachingRequestSentText: "Um coach entrará em contato em breve!",
    rewardsMarketplace: "Marketplace de recompensas",
    rewardsMarketplaceText: "Explorando recompensas e benefícios disponíveis!"
  },

  // Integrations
  integrations: {
    title: "Integrações",
    manageIntegrations: "Gerenciar integrações"
  },

  // Admins
  admins: {
    title: "Administradores",
    manageAdmins: "Gerenciar administradores"
  },

  //User Dashboard
  userDashboard: {
    expertIn: "Especialista em",
    knownFor: "Conhecido por",
    walletCard: "Carteira",
    activeQuest: "Plano de Crescimento",
    noDevelopmentPlans: "Nenhum plano de desenvolvimento ativo!",
    activityQueue: "Atividade de Aprendizagem",
    talentCard: "Cartão de Talento",
    developmentCharter: "Plano de Desenvolvimento",
    devchar: {
      suggested: "Sugerido",
      fuctionalSkills: "Competências Funcionais",
      softSkills: "Competências Comportamentais",
      news: "Notícias",
      activityQueue: "Fila de Atividades",
      completedItems: "Itens Concluídos"
    },
    sidebar: {
      dashboard: "Painel",
      boards: "Quadros",
      community: "Comunidade",
      wallet: "Carteira",
      notifications: "Notificações",
      myOrganizations: "Minhas Organizações"
    },
    notifications: {
      learningActions: "Ações de Aprendizagem",
      invites: "Administrador Convites",
      manage: "Gerenciar",
      acceptInvitation: "Aceitar Convite",
      noNotifications: "Nenhuma notificação encontrada!"
    },
    boards: {
      activeBoards: "Planos Ativos",
      archived: "Planos Arquivados",
      noBoards: "Não Existem Planos Ativos Atualmente",
      curate: "Ative os seus Planos de Carreira através da sua organização.",
      goToOrg: "Ir para Organizações"
    },
    wallet: {
      connectWallet: "Conectar Carteira",
      walletHistory: "Histórico da Carteira",
      status: "Status",
      date: "Data",
      amount: "Valor",
      transactions: "Transações",
      type: "Tipo",
      details: "Detalhes",
      done: "Concluído",
      noTransactions: "Nenhum dado disponível"
    },
    profileDropDown: {
      createOrganization: "Criar Organização",
      settings: "Configurações",
      logout: "Sair"
    },
    settings: {
      firstName: "Primeiro Nome",
      lastName: "Sobrenome",
      email: "Email",
      dateOfBirth: "Data de Nascimento",
      gender: "Gênero",
      about: "Sobre",
      saveChanges: "Salvar Alterações",
      account: "Conta"
    },
    evaluation: {
      evaluation: "Avaliação",
      searchPlaceholder: "Pesquisar funções ou candidatos...",
      importResumes: "Importar currículos",
      draganddrop: "Arraste e solte currículos aqui",
      clicktoselect: "ou clique para selecionar arquivos",
      supportedfiles: "Formatos suportados: PDF, DOC, DOCX, TXT",
      maxfile: "Máx. 10 arquivos por envio",
      notifications: "Notificações",
      norequests: "Nenhuma solicitação disponível",
      refreshchart: "Atualizar gráfico",
      processing: "Processando...",
      processed: "processado",
      waiting: "AGUARDANDO",
      totalprogress: "Progresso total",
      queue: "Fila",
      batchedqueued: "Lote(s) na fila",
      uploadbatch: "Enviar lote",
      hideandprocess: "Ocultar e processar em segundo plano",
      deleterole: "Excluir função",
      openrole: "Função aberta",
      closedrole: "Função fechada",
      addteammember: "Adicionar membro da equipe",
      editrole: "Editar definição da função",
      addroles: "Adicionar funções",
      deleteconfirmation: "Confirmação de exclusão",
      activeassignments: "Atribuições ativas",
      assignedcandidates: "candidato(s) estão atualmente atribuídos",
      deletewarning1: "Excluir esta função removerá todas as atribuições do organograma.",
      thisactioncannotbeundone: "Esta ação não pode ser desfeita.",
      confirmdelete: "Confirmar exclusão",
      subroles: "Subfunções detectadas",
      thisrolehassubroles: "Esta função tem",
      connectedsubrole: "subfunção(ões) conectada(s).",
      deletewarning2: "Excluir esta função removerá permanentemente todas as subfunções e desatribuirá todos os candidatos.",
      clicktoviewevaluation: "Clique para ver os dados de avaliação",
      searchcandidates: "Pesquisar candidatos...",
      autorejected: "Rejeitado automaticamente",
      candidates: "Candidatos",
      filterby: "Filtrar por função",
      moreoptions: "Mais opções",
      addtorole: "Adicionar à função",
      dismissprofile: "Descartar perfil",
      added: "Adicionado",
      fitmemtdetails: "Detalhes de adequação",
      addnewrole: "Adicionar nova função",
      roleTitle: "Título da função",
      purpose: "Qual é o propósito principal desta função? (uma linha)",
      selectlevel: "Selecionar nível",
      functionalSkills: "Habilidades funcionais",
      softSkills: "Habilidades comportamentais",
      responsibilities: "Responsabilidades",
      mission: "Missão (JTBD)",
      primarygoal: "Objetivo principal: a #1 coisa que esta função deve alcançar",
      secondarygoal: "Objetivo secundário: objetivo de suporte",
      generateroledescription: "Gerar descrição da função",
      previewanddownload: "Visualizar e baixar JD",
      createrole: "Criar função",
      nvr: "Sem reconhecimento de valor com impacto direto mínimo nos negócios",
      kvdrdetection: "Detecção KVDR",
      currentclassification: "Classificação atual",
      influence: "Influência",
      whatdrivesthisrole: "O QUE GERA VALOR NESTA FUNÇÃO?",
      person: "A pessoa",
      role: "A função em si",
      whatkidnofvalue: "QUE TIPO DE VALOR? (selecione todos que se aplicam)",
      revenue: "Receita",
      cost: "Custo",
      risk: "Risco",
      ops: "Operações",
      brand: "Marca",
      social: "Social",
      research: "Pesquisa",
      other: "Outro",
      ip: "PI",
      canthisvalue: "ESTE VALOR PODE SER EXPRESSO EM TERMOS DE NEGÓCIO?",
      revenue: "Receita gerada",
      costsaved: "Custos economizados",
      timereduced: "Tempo reduzido",
      qualityimproved: "Qualidade melhorada",
      riskmitigated: "Risco mitigado",
      capabilitybuilt: "Capacidade desenvolvida",
      valueinfluencescore: "PONTUAÇÃO DE INFLUÊNCIA DE VALOR",
      noinfluence: "Sem influência",
      directdriver: "Driver direto",
      ownershipclarity: "CLAREZA DE RESPONSABILIDADE",
      diffuse: "Difuso / pouco claro",
      clear: "Um responsável claro",
      svr: "Permite KVDRs contribuição indireta",
      kvdr: "Driver direto da criação de valor",
      editrole: "Editar função",
      saveChanges: "Salvar alterações",
      back: "Voltar",
      done: "Concluído",
      jobdescription: "Descrição do trabalho",
      notspecified: "Não especificado",
      todriveorgsuccess: "Para impulsionar o sucesso organizacional",
      untitledrole: "Função sem título",
      roledescription: "Descrição da função",
      nodescription: "Nenhuma descrição fornecida.",
      nonespecified: "Nenhum especificado",
      goals: "Objetivos",
      notspecified: "Não especificado",
    },
    organization_design: {
      organizationDesign: "Design organizacional",
      rootnode: "Nó raiz da organização",
      description: "Este é o nó raiz que representa a organização. Você não pode inspecioná-lo ou editá-lo como uma função padrão. Por favor, selecione cartões de função padrão para modificá-los.",
      gotit: "Entendi",
      totalheadcount: "Total de colaboradores",
      selecttool: "Selecionar ferramenta",
      zoomin: "Aumentar zoom",
      zoomout: "Diminuir zoom",
    },
    "careerSimulator": {
      uploadBlocked: "Upload Bloqueado",
      gotIt: "Entendi",
      keyAchievements: "PRINCIPAIS CONQUISTAS",
      appliedSkills: "HABILIDADES APLICADAS",
      careerTrajectory: "Trajetória de Carreira",
      careerDurationFlow: "UM FLUXO DE {duration} ANOS DE CARGOS, PROJETOS E HABILIDADES",
      experienceFlow: "FLUXO DE EXPERIÊNCIA",
      projectedNextMove: "PRÓXIMO PASSO PROJETADO",
      zoomIn: "Mais Zoom",
      zoomOut: "Menos Zoom",
      resetView: "Redefinir Vista",
      careerPeak: "🚀 PICO DA CARREIRA",
      now: "AGORA",
      complexity: "⚡ COMPLEXIDADE {score}/10",
      aiPredictedNextStep: "PRÓXIMO PASSO PREVISTO POR IA",
      externalMarketGoal: "Meta do Mercado Externo",
      futureNodeDesc: "Com base no caminho escolhido, este é o cargo pináculo definitivo a ser alcançado.",
      scrubHint: "Clique e arraste para mover · Use o scroll ao longo da linha · Clique em qualquer cartão para inspecionar",
      noCareerHistoryTitle: "Sem Histórico de Carreira",
      noCareerHistoryDesc: "Não conseguimos extrair datas válidas suficientes do currículo para construir a linha do tempo.",
      close: "Fechar",
      startWithCv: "Comece com seu currículo",
      startWithCvDesc: "Analisamos um exemplo de leitura de currículo. Você pode enviar o seu — extrairemos automaticamente habilidades, projetos e velocidade de aprendizado.",
      uploadYourResume: "Carregar seu Currículo",
      dragDropBrowse: "Arraste e solte seu arquivo aqui ou navegue • PDF, DOCX, DOC",
      selectFile: "Selecionar Arquivo",
      deepAiScan: "Varredura Avançada de IA em Andamento",
      activeDocument: "Documento Ativo",
      changeFile: "Alterar Arquivo",
      uploadedResumeTitle: "Seu Currículo Carregado",
      storedInDb: "Armazenado no Banco de Dados",
      loadedFromIntelligenceDb: "Carregado do Banco de Dados de Inteligência",
      identifyingCandidate: "IDENTIFICANDO CANDIDATO",
      parsingIdentity: "Analisando Identidade...",
      careerVelocity: "Velocidade de Carreira:",
      scanning: "Varrendo...",
      extractingSkills: "EXTRAINDO HABILIDADES...",
      simulatingRoleFit: "SIMULANDO COMPATIBILIDADE DE CARGO...",
      primaryPathway: "Caminho Principal",
      secondaryTarget: "Alvo Secundário",
      stretchRole: "Cargo de Expansão (Stretch)",
      parsedScan: "ANÁLISE PROCESSADA",
      topSkills: "PRINCIPAIS HABILIDADES",
      moreCount: "+{count} mais ➔",
      showLess: "← Mostrar menos",
      bestFitRolesTitle: "MELHORES CARGOS (DO CURRÍCULO)",
      typeOfWorkTitle: "Tipo de Trabalho",
      typeOfWorkSubtitle: "Que tipo de trabalho você deseja fazer?",
      selectTargetArea: "Selecione a Área Temática...",
      otherWriteOwn: "Outro — escreva o seu...",
      typeCustomTarget: "Digite sua área temática personalizada...",
      typeOfWorkExamples: "Exemplos: Comunicação, Construção de Equipes, Programação, Criativo, Analítico, Vendas, Consultoria...",
      industryFocusTitle: "Foco do Setor",
      industryFocusSubtitle: "Em qual campo de interesse você deseja crescer?",
      selectIndustryFocus: "Selecione o Foco do Setor...",
      typeCustomIndustry: "Digite seu setor personalizado...",
      supportingSkillsTitle: "Habilidades de Apoio",
      supportingSkillsSubtitle: "Selecione ou adicione várias habilidades que apoiam esta carreira.",
      typeCustomSkill: "+ Digite uma habilidade personalizada e pressione Enter...",
      alternateSkillsTitle: "Habilidades Alternativas",
      alternateSkillsSubtitle: "Selecione ou adicione habilidades secundárias que você deseja aprender.",
      typeCustomStretchSkill: "+ Digite uma habilidade de expansão personalizada e pressione Enter...",
      alternatePathwaysTitle: "Seus Caminhos Alternativos de Carreira",
      alternatePathwaysSubtitle: "Ancorado em \"{area}\". Clique em um nó de cargo para revelar sua previsão detalhada.",
      skillReadiness: "Prontidão de Habilidades",
      timeReadiness: "Prontidão Temporal",
      viewingInternalTooltip: "Visualizando Organização Interna (Clique para Mercado)",
      viewingMarketTooltip: "Visualizando Mercado Geral (Clique para Interno)",
      targetFunctionalArea: "Área Funcional Alvo",
      careerTitlesProfession: "Cargos de Carreira / Profissão",
      requiredSkills: "Habilidades Requeridas",
      viewCareerHistoryTooltip: "Visualizar Histórico de Carreira",
      targetArea: "Área Alvo",
      roleNodeMeta: "Compatibilidade {fit}% • {time} • Clique para detalhes",
      have: "Possui",
      stretchWillingToLearn: "Expansão (disposto a aprender)",
      gap: "Lacuna",
      hoverNodeHint: "Passe o mouse sobre qualquer nó para isolar seu fluxo",
      shortTerm: "Curto Prazo",
      longTerm: "Longo Prazo",
      growthBanner: "CRESCIMENTO DE CARREIRA INCLUSIVO • PARTICIPATIVO • ENGAJADOR • ITERATIVO",
      today: "HOJE",
      identificationActions: "Ações de Identificação",
      risk: "- Risco",
      readyNowMonths: "PRONTO AGORA • 0 MESES",
      riskDesc: "Assuma esses cargos hoje — sua base de habilidades atual já cobre os requisitos principais.",
      emptyPaths: "Sem caminhos nesta janela.",
      developmentAction: "Ação de Desenvolvimento",
      potential: "+ Potencial",
      readyShortlyMonths: "PRONTO EM BREVE • 1-6 MESES",
      potentialDesc: "Planeje, ofereça e desenvolva habilidades e comportamentos escassos para desbloquear esses caminhos dentro de dois trimestres.",
      opportunityAllocation: "Alocação de Oportunidades",
      success: "= Sucesso",
      readyLaterMonths: "PRONTO MAIS TARDE • 6+ MESES",
      successDesc: "Construa uma trilha de talentos — esses caminhos exigem maior investimento em capacidade, mas desbloqueiam um crescimento de maior trajetória.",
      openRolesTitle: "Vagas abertas que correspondem aos seus caminhos",
      openRolesSubtitle: "Mapeamos seus caminhos de carreira previstos contra vagas atualmente abertas com base na sobreposição de habilidades requeridas.",
      matchPercent: "{percent}% de compatibilidade",
      mappedFromPath: "Mapeado do seu caminho: {path}",
      youHave: "VOCÊ TEM",
      stillMissing: "AINDA FALTA",
      requesting: "Solicitando...",
      acceptedByAdmin: "✓ Aceito pelo Administrador!",
      declined: "❌ Recusado",
      requestSent: "⌛ Solicitação Enviada...",
      requestJoin: "Solicitar Participação no Cargo",
      noExactMatchesTitle: "Sem correspondências exatas no momento",
      noExactMatchesDesc: "Nenhuma vaga aberta corresponde atualmente aos seus caminhos gerados nesta organização.",
      department: "DEPARTAMENTO",
      overallFit: "Compatibilidade geral",
      youAlreadyHave: "VOCÊ JÁ TEM",
      gapToClose: "LACUNA A PREENCHER",
      none: "Nenhum",
      back: "← Voltar",
      nextStep: "Próximo Passo ➔",
      seePredictions: "Ver Previsões ➔",
      generating: "Gerando...",
      matchOpenRoles: "Corresponder Vagas Abertas ➔",
      finishSaveProfile: "Finalizar e Salvar Perfil",
      secBlockError: "BLOQUEIO DE SEGURANÇA: O currículo enviado pertence a {email}, mas você está conectado como {userEmail}.",
      failedResumeLoad: "Não foi possível carregar o arquivo de currículo do banco de dados.",
      failedPredict: "Falha ao gerar caminhos de carreira completos.",
      failedSave: "Falha ao salvar as métricas.",
      failedRequest: "Falha ao solicitar o cargo. Tente novamente.",
      failedParse: "Falha ao analisar o currículo.",
      radarInitializing: "Inicializando mecanismos neurais...",
      radarStructuring: "Estruturando nós de documentos...",
      radarSkeptical: "Executando Análise de RH Cética...",
      radarExtracting: "Extraindo capacidades técnicas...",
      radarSimulating: "Simulando caminhos de carreira...",
      radarFinalizing: "Finalizando pontuações de inteligência de RH...",
      aiMachineLearning: "IA e Aprendizado de Máquina",
      backendDevelopment: "Desenvolvimento Backend",
      softwareEngineering: "Engenharia de Software",
      dataAnalytics: "Dados e Análise",
      infrastructure: "Infraestrutura",
      architectureConsulting: "Arquitetura e Consultoria",
      saas: "SaaS",
      fintech: "FinTech",
      healthtech: "HealthTech",
      ecommerce: "E-commerce",
      consulting: "Consultoria"
    }
  }
};
